import { apiEntityFetch, apiEntityViewsFetch } from '..';
import type {
  RejectRoleRequestBody,
  RoleRequestCreatedResponse,
  RoleRequestInput,
  RoleRequestListParams,
  RoleRequestListResponse,
} from './types';

export type RoleRequestsClient = {
  create: (_input: RoleRequestInput) => Promise<RoleRequestCreatedResponse>;
  list: (_params: RoleRequestListParams) => Promise<RoleRequestListResponse>;
  approve: (_requestId: string) => Promise<void>;
  reject: (_requestId: string, _body: RejectRoleRequestBody) => Promise<void>;
};

export const roleRequestsClient: RoleRequestsClient = {
  create: (body) =>
    apiEntityFetch<RoleRequestCreatedResponse>('/role-requests', { method: 'POST', body }),
  list: ({ status }) =>
    apiEntityViewsFetch<RoleRequestListResponse>('/role-requests', {
      params: { status },
    }),

  approve: (requestId) =>
    apiEntityFetch<void>(`/role-requests/${encodeURIComponent(requestId)}/approve`, {
      method: 'POST',
    }),

  reject: (requestId, body) =>
    apiEntityFetch<void>(`/role-requests/${encodeURIComponent(requestId)}/reject`, {
      method: 'POST',
      body,
    }),
};
